module.exports = __webpack_public_path__ + "static/img/gpt56.1f33c587.png";